// extracted by mini-css-extract-plugin
export default {"copy":"cfa-z","linkButton":"dfa-z"};